import CollectionModule from 'client/store/modules/CollectionModule';
import PasswordManagerAppVersionApi from 'client/api/v2/PasswordManagerAppVersionApi';
import Vue from 'vue';

export const PasswordManagerAppVersionCollection = (Api = PasswordManagerAppVersionApi) => {
  const collection = new CollectionModule(Api, 'version', '');
  const PasswordManagerAppVersionCollectionModule = collection.extractModule();

  const SET_OS = 'SET_OS';
  const UPDATE_REFRESH_KEY = 'UPDATE_REFRESH_KEY';

  const getInitialState = () => {
    const { state } = PasswordManagerAppVersionCollectionModule;
    state.refreshKey = 0;
    state.os = '';
    return state;
  };

  return {
    namespaced: true,

    state: getInitialState(),

    actions: {
      ...PasswordManagerAppVersionCollectionModule.actions,

      updateRefreshKey({ commit }) {
        commit(UPDATE_REFRESH_KEY);
      },

      setOS({ commit }, os) {
        commit(SET_OS, os);
      },
    },

    getters: {
      ...PasswordManagerAppVersionCollectionModule.getters,

      refreshKey(state) {
        return state.refreshKey;
      },
    },

    mutations: {
      ...PasswordManagerAppVersionCollectionModule.mutations,

      [SET_OS](state, os) {
        Vue.set(state, 'os', os);
      },

      [UPDATE_REFRESH_KEY](state) {
        Vue.set(state, 'refreshKey', state.refreshKey + 1);
      },
    },
  };
};

export default PasswordManagerAppVersionCollection();
